<script>
import { mapGetters } from 'vuex'

import appHeader from '@/components/app-header/app-header'
import appFooter from '@/components/app-footer/app-footer'

export default {
  name: 'app-smart-catalog-layout',
  components: { appHeader, appFooter },
  data() {
    return {
      scrollY: 0,
      isScrollUp: true,
      isHeaderHidden: false,
      headerHeight: null,
    }
  },
  computed: {
    ...mapGetters({
      isMobileVersion: 'isMobileVersion',
      showAll: 'showAll',
    })
  },
  methods: {
    onScroll() {
      if (this.isMobileVersion) {
        if (this.scrollY + this.headerHeight < window.scrollY) {
          this.isScrollUp = false;
          this.scrollY = window.scrollY
        } else if (this.scrollY - this.headerHeight > window.scrollY) {
          this.isScrollUp = true;
          this.scrollY = window.scrollY
        }
        
        if (this.isScrollUp && this.isHeaderHidden) {
          this.isHeaderHidden = false
        } else if (!this.isScrollUp && !this.isHeaderHidden) {
          this.isHeaderHidden = true
        }
      }
    }
  },
  mounted() {
    this.headerHeight = document.querySelector('header').clientHeight + 32
    window.addEventListener('scroll', this.onScroll)
  }
}
</script>

<template>
  <div class="bg-white flex flex-col min-h-screen justify-between">
    <app-header 
      :isHeaderHidden="isHeaderHidden"
      :isMobileVersion="isMobileVersion"
    />
    <div 
      class="bg-white container flex flex-grow mt-4"
    >
      <router-view></router-view>
    </div>
    <app-footer/>
  </div>
</template>

<style scoped>
</style>
